/*
  PEACE OUT product page: show the selected size on the ADD TO CART button ("カートに追加 — M").
  The theme re-renders parts of the product form when the variant changes, so this
  watches the product info area and re-applies the label when needed.
*/
(() => {
  const info = document.querySelector('.product__info-container');
  if (!info) return;

  const update = () => {
    const label = info.querySelector('.product-form__submit > span:not(.loading__spinner)');
    if (!label) return;
    const checked = info.querySelector('.po-option--size input[type="radio"]:checked');
    const size = checked ? checked.value : '';
    if (size && label.dataset.poSize !== size) label.dataset.poSize = size;
    if (!size && label.dataset.poSize) delete label.dataset.poSize;
  };

  update();
  info.addEventListener('change', () => requestAnimationFrame(update));
  new MutationObserver(() => update()).observe(info, { childList: true, subtree: true, characterData: true });
})();
